import {DIASRENDIMENTOS} from "../../Constantes";
import dayjs from 'dayjs';

export const obtenerFechaProximosDeposito = ({bolsillo, numCuotasPagas, numCuotasDebeTener = 0}) => {

    if (!numCuotasPagas) {
        numCuotasPagas = 0;
    }

  //  console.log('NumCuotas Pagas: ' + numCuotasPagas);

    let hoy = dayjs()

    const fechaHoy = dayjs(new Date());
    const fechaInicio = dayjs(bolsillo.fecha);

// Resultado entero (meses completos)
    const mesesCompletos = Math.ceil(fechaHoy.diff(fechaInicio, 'month', true))


    if (bolsillo.dias === DIASRENDIMENTOS[0].nombre) {
        return new Date(hoy.add(mesesCompletos + numCuotasPagas - numCuotasDebeTener, 'month').set('date', 5).format('YYYY-MM-DD'))
    } else {
        return new Date(hoy.add(mesesCompletos + numCuotasPagas - numCuotasDebeTener, 'month').set('date', 30).format('YYYY-MM-DD'))
    }


}